var _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawFilterCoursePlaylist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 643,
    height: 447.57029,
    viewBox: "0 0 643 447.57029",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M891.62348,313.02059H308.47961a29.96193,29.96193,0,0,1-29.92806-29.92807V255.88519a29.96193,29.96193,0,0,1,29.92806-29.92807H891.62348a29.96193,29.96193,0,0,1,29.92807,29.92807v27.20733A29.96193,29.96193,0,0,1,891.62348,313.02059ZM308.47961,227.77094a28.14617,28.14617,0,0,0-28.11424,28.11425v27.20733a28.14617,28.14617,0,0,0,28.11424,28.11425H891.62348a28.14617,28.14617,0,0,0,28.11424-28.11425V255.88519a28.14617,28.14617,0,0,0-28.11424-28.11425Z",
    transform: "translate(-278.55155 -225.95712)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.1354,
    y: 26.30042,
    width: 421.71368,
    height: 34.46262,
    rx: 17.23129,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.92243,
    y: 177.43018,
    width: 421.71368,
    height: 34.46262,
    rx: 17.23129,
    fill: "#ce93d8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.92243,
    y: 287.00423,
    width: 421.71368,
    height: 34.46262,
    rx: 17.23129,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 107.92243,
    y: 396.57828,
    width: 421.71368,
    height: 34.46262,
    rx: 17.23129,
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M864.86391,288.10449a2.71409,2.71409,0,0,1-3.7799.66654l-14.80667-10.30275a2.714,2.714,0,1,1,3.11336-4.44644l14.80667,10.30275A2.71408,2.71408,0,0,1,864.86391,288.10449Z",
    transform: "translate(-278.55155 -225.95712)",
    fill: "#ce93d8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M848.054,276.39907a19.26672,19.26672,0,1,1-4.73174-26.83326A19.28854,19.28854,0,0,1,848.054,276.39907Zm-27.61937-19.33883a14.45,14.45,0,1,0,20.12494-3.5488A14.46638,14.46638,0,0,0,820.43461,257.06024Z",
    transform: "translate(-278.55155 -225.95712)",
    fill: "#ce93d8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M874.84562,454.28942H325.25747a.90691.90691,0,1,1,0-1.81382H874.84562a.90691.90691,0,1,1,0,1.81382Z",
    transform: "translate(-278.55155 -225.95712)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M874.84562,563.90864H325.25747a.90691.90691,0,0,1,0-1.81382H874.84562a.90691.90691,0,0,1,0,1.81382Z",
    transform: "translate(-278.55155 -225.95712)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M874.84562,673.52741H325.25747a.90691.90691,0,0,1,0-1.81382H874.84562a.90691.90691,0,1,1,0,1.81382Z",
    transform: "translate(-278.55155 -225.95712)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawFilterCoursePlaylist);
export default __webpack_public_path__ + "static/media/undraw_filter_course_playlist.6c0431428df1f25a5af3395f280b8465.svg";
export { ForwardRef as ReactComponent };